import { render, staticRenderFns } from "./Bankbay.vue?vue&type=template&id=569968e6&"
import script from "./Bankbay.vue?vue&type=script&lang=js&"
export * from "./Bankbay.vue?vue&type=script&lang=js&"
import style0 from "./Bankbay.vue?vue&type=style&index=0&id=569968e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports